import { createSlice } from "@reduxjs/toolkit";

export const dealerCommFilterSlice = createSlice({
  name: "filters",
  initialState: {
    filters: {},
    loanApplicationCaseFilter: {},
    loanAppDetailsFilter: {},
    flooringRateFilter: {},
    flooringVouchersFilter: {},
    initialLoanApplicationFilter: {}
  },
  reducers: {
    setFilters: (state, action) => {
      return { ...state, ["filters"]: { ...action.payload } };
    },
    setLoanApplicationCaseFilter: (state, action) => {
      return { ...state, loanApplicationCaseFilter: action.payload };
    },
    setLoanApplicationDetailsFilter: (state, action) => {
      return {
        ...state,
        loanAppDetailsFilter: {
          ...state.loanAppDetailsFilter,
          ...action.payload,
        },
      };
    },
    setFlooringRateFilter: (state, action) => {
      return {
        ...state, flooringRateFilter: {
          ...state.flooringRateFilter,
          ...action.payload,
        }
      };
    },
    setFlooringVoucherFilter: (state, action) => {
      return {
        ...state, flooringVouchersFilter: {
          ...state.flooringVouchersFilter,
          ...action.payload,
        }
      };
    },
    setInitialLoanApplicationFilter: (state, action) => {
      return { ...state, initialLoanApplicationFilter: action.payload };
    },
    resetLoanAppFilter: (state) => {
      return {
        ...state,
        loanApplicationCaseFilter: {},
        loanAppDetailsFilter: {},
        filters: {},
        flooringRateFilter: {},
        flooringVouchersFilter: {},
        initialLoanApplicationFilter: {}
      };
    },
  },
});

export const {
  setFilters,
  setLoanApplicationCaseFilter,
  setLoanApplicationDetailsFilter,
  resetLoanAppFilter,
  setFlooringRateFilter,
  setFlooringVoucherFilter,
  setInitialLoanApplicationFilter
} = dealerCommFilterSlice.actions;

export default dealerCommFilterSlice.reducer;
